import { forwardRef } from "react";

import { NumberField as BaseNumberField } from "@base-ui/react/number-field";

import { cn } from "..";

const NumberFieldGroup = forwardRef<HTMLDivElement, React.ComponentPropsWithRef<typeof BaseNumberField.Group>>(
  (props, forwardedRef) => {
    const { className, ...groupProps } = props;
    return (
      <BaseNumberField.Group
        {...groupProps}
        ref={forwardedRef}
        className={cn("flex flex-1 items-stretch", className)}
      />
    );
  },
);

NumberFieldGroup.displayName = "NumberField.Group";

export default NumberFieldGroup;
